(() => {
    const storeLevelCommsVariables = [
        "{StoreContactNumber}",
        "{StoreName}",
        "{StorePhysicalAddress}"
    ];

    class ManageCampaignTemplateConfirmationController {
        /**
         * @type {CampaignTemplate}
         */
        campaignTemplate;
        userContext;
        warnAboutStoreVariables;

        constructor(
            $scope,
            $state,
            CampaignDesignerService,
            ErrorService,
            PermissionService,
            notify,
            DTOptionsBuilder,
            DTColumnBuilder,
            $q,
            $sce,
            LocalisationService,
            NgTableParams,
            StoresService,
            DashboardConfig
        ) {

            this.$scope = $scope;
            this.$state = $state;
            this.CampaignDesignerService = CampaignDesignerService;
            this.ErrorService = ErrorService;
            this.PermissionService = PermissionService;
            this.notify = notify;
            this.DTOptionsBuilder = DTOptionsBuilder;
            this.DTColumnBuilder = DTColumnBuilder;
            this.$q = $q;
            this.$sce = $sce;
            this.LocalisationService = LocalisationService;
            this.NgTableParams = NgTableParams;
            this.StoresService = StoresService;
            this.DashboardConfig = DashboardConfig;

            this.menuScriptsGrid = undefined;
            this.vouchersGrid = undefined;
            this.menuScriptsGridLoaded = false;
            this.vouchersGridLoaded = false;

            this.dateFormat = LocalisationService.Configuration.DateFormat;
            this.CampaignTemplateCommunicationTypes = Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes;

            this.statuses = Object.entries(Dashboard.Models.Lookups.CampaignTargetSourceStatuses)
                .map(([ key, value ]) => ({
                    key,
                    value
                }));
            this.types = Object.entries(Dashboard.Models.Lookups.CampaignLevels)
                .map(([ key, value ]) => ({
                    key,
                    value
                }));

            this.colWidth = '50px';
        }

        goTo(state) {
            this.$state.go(
                Dashboard.helpers.stateHelper.getParentState(this.$state.current.name) + state, {
                    brandId: this.$state.params.brandId,
                    CampaignTemplateGuid: this.campaignTemplate.TemplateGuid
                });
        }

        $onInit() {
            this.warnAboutStoreVariables = false;
            this.vouchersGrid = {
                hasError: false
            };
            this.menuScriptsGrid = {
                hasError: false
            };

            if (!this.campaignTemplate || !this.campaignTemplate.TemplateGuid) {
                this.ErrorService.showError('An error occurred when loading the campaign template');
                return;
            }
            this.userContext = this.PermissionService.userContext;
            this.brandName = this.userContext.BrandName;
            this.isAvailableToAllStores = isAvailableToAllStores(this.campaignTemplate);
            this.isStoreContext = this.campaignTemplate.CampaignLevelId === Dashboard.Models.Lookups.CampaignLevels.Store;

            this.checkForStoreVariablesInBrandLevelCampaign();
            this.setReplacementButtonText();

            this.CampaignCommunicationTextReplacementService = new window.CampaignCommunicationTextReplacementService(
                this,
                this.$state.params.brandId,
                this.StoresService,
                this.ErrorService,
                this.DashboardConfig
            ).initialiseForCampaign(this.campaignTemplate);

            this.setupGrids();
        }

        checkForStoreVariablesInBrandLevelCampaign() {
            if (!this.campaignTemplate) {
                return;
            }
            if (this.isStoreContext) {
                return;
            }
            const comms = this.campaignTemplate.Communications || [];
            for (const comm of comms) {
                for (const v of storeLevelCommsVariables) {
                    if (this.communicationTextContainsStoreVariable(comm)) {
                        this.warnAboutStoreVariables = true;
                        return;
                    }
                }
            }
        }

        communicationTextContainsStoreVariable(comm) {
            const texts = [
                comm?.SMS?.Text,
                comm?.PushNotification?.Text,
                comm?.InboxMessage?.Text,
                comm?.InboxMessage?.Template
            ].filter(s => !!s);
            for (const text of texts) {
                if (this.containsAnyOf(text, storeLevelCommsVariables)) {
                    return true;
                }
            }

            return false;
        }

        containsAnyOf(haystack, needles) {
            for (const needle of needles) {
                if (haystack.includes(needle)) {
                    return true;
                }
            }
            return false;
        }

        setReplacementButtonText() {
            this.publishButtonText = this.campaignTemplate.IsDraft()
                ? "Publish"
                : "Published";
        }

        replaceVariables(communication, messageType) {
            let inboxMessageValue = "";
            if (communication.InboxMessage) {
                inboxMessageValue = communication.InboxMessage.Template;
            }

            return this.CampaignCommunicationTextReplacementService.replaceVariables(
                messageType,
                this.userContext.BrandName,
                inboxMessageValue,
                communication
            );
        };

        setupMenuScriptsGrid() {
            this.menuScriptsGrid.dtOptions = this.DTOptionsBuilder
                .fromFnPromise(() => this.getMenuScriptData())
                .withOption('paging', true)
                .withOption('searching', true)
                .withOption('processing', true)
                .withPaginationType('full_numbers')
                .withOption('responsive', true)
                .withOption('order', [ [ 0, 'asc' ] ]);


            this.menuScriptsGrid.dtColumns = [
                this.DTColumnBuilder.newColumn('Name')
                    .withTitle('Name')
                    .withOption('width', this.colWidth),
                this.DTColumnBuilder.newColumn('MenuScriptGuid')
                    .withTitle('Menu Script Guid')
                    .withOption('width', this.colWidth),
                this.DTColumnBuilder.newColumn('EstimatedDiscount')
                    .withTitle('Estimated Discount')
                    .withOption('width', this.colWidth)
            ];

            this.menuScriptsGrid.dtInstance = null;
            this.menuScriptsGridLoaded = true;
        }

        setupVouchersGrid() {
            this.vouchersGrid.dtOptions = this.DTOptionsBuilder
                .fromFnPromise(() => this.getVouchersData())
                .withOption('paging', true)
                .withOption('searching', true)
                .withOption('processing', true)
                .withPaginationType('full_numbers')
                .withOption('responsive', true)
                .withOption('order', [ [ 1, 'desc' ] ]);

            this.vouchersGrid.dtColumns = [
                this.DTColumnBuilder.newColumn('Name')
                    .withTitle('Name')
                    .withOption('width', this.colWidth),
                this.DTColumnBuilder.newColumn('VoucherCode')
                    .withTitle('Voucher')
                    .withOption('width', this.colWidth),
                this.DTColumnBuilder.newColumn('EstimatedOrderDiscount')
                    .withTitle('Estimated Discount')
                    .withOption('width', this.colWidth)
            ];
            this.vouchersGrid.dtInstance = null;
            this.vouchersGridLoaded = true;
        }

        setupTargetSourceGrid() {
            this.templateTargetSourcesTableParams = new this.NgTableParams(
                {
                    count: this.campaignTemplate.CampaignTemplateTargetSources.length
                }, {
                    counts: [],
                    getData: () => {
                        return this.campaignTemplate.CampaignTemplateTargetSources
                            .map(x => {
                                x.StatusName = this.statuses.find(s => s.value === x.StatusId).key;
                                return x;
                            })
                            .sort((a, b) => a.DisplayOrder - b.DisplayOrder);
                    }
                });
        }

        setupGrids() {
            this.setupVouchersGrid();
            this.setupMenuScriptsGrid();
            this.setupTargetSourceGrid();
        }

        // provides an "async" loader for the data table
        getMenuScriptData() {
            const deferred = this.$q.defer();
            deferred.resolve(this.campaignTemplate.MenuScripts);
            return deferred.promise;
        }

        // provides an "async" loader for the data table
        getVouchersData() {
            const deferred = this.$q.defer();
            deferred.resolve(this.campaignTemplate.Vouchers);
            return deferred.promise;
        }

        publish() {
            this.$scope.$root.isLoading = true;

            this.CampaignDesignerService.publishCampaignTemplate(
                this.campaignTemplate.TemplateGuid
            ).then(() => {
                    this.notify.success('The campaign template was successfully published');
                    this.$state.go(
                        window.Dashboard.helpers.stateHelper.getGrandparentState(
                            this.$state.current.name
                        ) + '.published',
                        {
                            brandId: this.$state.params.brandId
                        });
                }
            ).catch(err => {
                    this.ErrorService.showError(
                        'An error occurred when publishing the campaign template',
                        err
                    );
                }
            ).finally(() => {
                    this.$scope.$root.isLoading = false;
                }
            );
        }

        getCampaignLevel() {
            const levels = window.Dashboard.Models.Lookups.CampaignLevels;
            switch (this.campaignTemplate.CampaignLevelId) {
                case levels.All: // 1:
                    return 'Store And Brand Level';
                case levels.Brand: // 2:
                    return 'Brand Level';
                case levels.Store: // 3:
                    return 'Store Level';
                default:
                    this.ErrorService.showError(
                        'Campaign template campaign level id is out of range',
                        this.campaignTemplate
                    );
                    return 'Out Of Range';
            }
        }

        get shouldShowCommunications() {
            return this.campaignTemplate &&
                this.campaignTemplate.HasCommunication();
        }

        formatDate(date) {
            return this.LocalisationService.formatDateShort(date);
        }
    }

    function isAvailableToAllStores(campaignTemplate) {
        if (campaignTemplate.StoreAssociations.length !== 1) {
            return false
        }
        const store = campaignTemplate.StoreAssociations[0];
        return store.Id === 0;
    }


    angular
        .module('dashboard')
        .component('manageCampaignTemplateConfirmation',
            {
                templateUrl: 'components/campaigndesigner/managecampaigntemplates/confirmation/campaigntemplateconfirmation.d61d93a7.html',
                bindings: {
                    campaignTemplate: '=',
                    userContext: '<'
                },
                controller: [
                    '$scope',
                    '$state',
                    'CampaignDesignerService',
                    'ErrorService',
                    'PermissionService',
                    'notify',
                    'DTOptionsBuilder',
                    'DTColumnBuilder',
                    '$q',
                    '$sce',
                    'LocalisationService',
                    'NgTableParams',
                    'StoresService',
                    'DashboardConfig',
                    ManageCampaignTemplateConfirmationController ]
            });
})();
